/* @jsx h */
const QueryCheckbox = ({
  label,
  setPopularSearchTermAsInputQuery,
  handleReset,
  pluginNamespace,
  isMainSearch,
  inputQuery,
}) => {
  function updateSearchQuery(e) {
    e.target.checked
      ? setPopularSearchTermAsInputQuery(e.target.value)
      : handleReset();
  }

  function check() {
    return inputQuery && label === inputQuery;
  }

  return (
    <li className="filter__item">
      <input
        id={`checkbox-${label}`}
        type="checkbox"
        value={label}
        onChange={updateSearchQuery}
        checked={check()}
        className="sr-only filter__checkbox"
      />
      <label
        htmlFor={`checkbox-${label}`}
        className={`btn ${isMainSearch ? 'btn--tertiary' : 'btn--secondary'}`}
      >
        {label}
      </label>
    </li>
  );
};

export default QueryCheckbox;
